import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFlagOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], u = /* @__PURE__ */ a("path", { d: "M3.5 1A.5.5 0 0 1 4 .5c.847 0 1.548.28 2.158.525l.028.01C6.82 1.29 7.36 1.5 8 1.5c.694 0 1.13-.115 1.377-.214a1.341 1.341 0 0 0 .28-.15.5.5 0 0 1 .843.364V7a.5.5 0 0 1-1 0V2.302c-.364.112-.854.198-1.5.198-.847 0-1.548-.28-2.158-.525l-.028-.01C5.18 1.71 4.64 1.5 4 1.5a.5.5 0 0 1-.5-.5ZM1.354.646a.5.5 0 1 0-.708.708l.854.853V11a.5.5 0 0 0 1 0V7.769c.035-.017.076-.036.123-.055C2.87 7.615 3.306 7.5 4 7.5c.64 0 1.18.21 1.814.464l.028.011c.558.224 1.193.477 1.945.52l2.86 2.859a.5.5 0 0 0 .707-.708l-10-10ZM4 6.5c.847 0 1.548.28 2.158.525l.028.01.237.095L2.5 3.207v3.491c.364-.112.854-.198 1.5-.198Z" }, null, -1), h = [
  u
], p = ["id"], m = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  m
];
function v(e, I, l, C, b, t) {
  return n(), r("svg", {
    "aria-label": l.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--flag-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Flag Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, h, 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, p)
    ])
  ], 10, _);
}
const D = /* @__PURE__ */ s(c, [["render", v]]);
export {
  D as default
};
//# sourceMappingURL=flag-off.js.map
